// REPLACE WITH REAL DATA — Success Stories of Patrick's Edu Care students.
// Swap `image`, `name`, `from`, `quote`, `parentQuote`, `outcome` etc. with real student stories.
// Photos: ideally a clean portrait in campus/student-life context.

export const successStories = [
  {
    slug: 'dr-gayathri-satheesh-caucasus-mbbs',
    name: 'Dr. Gayathri Satheesh',
    from: 'Kerala',
    age: 25,
    year: '2025',
    program: 'MBBS',
    programSlug: 'mbbs',
    country: 'Georgia',
    countrySlug: 'georgia',
    university: 'Caucasus University, Tbilisi',
    image: '/img/iuav9tlz_photo-2026-02-04-14-22-21.webp',
    quote: 'Studying MBBS at Caucasus University changed my life. Patrick sir personally guided me through every milestone — admissions, exams, clinical rotations. Clearing FMGE in my very first attempt with 227 marks is the proudest moment of my journey.',
    parentQuote: '"We trusted Patrick\'s Edu Care with our daughter\'s future — today she is a licensed doctor in India. Nothing means more to us." — Dr. Gayathri\'s Family',
    outcome: 'Graduated 2025 · Cleared FMGE in 1st attempt with 227 marks · Now a licensed doctor in India',
    badges: ['FMGE 1st Attempt', '227 Marks', 'NMC Licensed']
  },
  {
    slug: 'dr-anamika-unnikrishnan-caucasus-mbbs',
    name: 'Dr. Anamika Unnikrishnan',
    from: 'Kerala',
    age: 25,
    year: '2024',
    program: 'MBBS',
    programSlug: 'mbbs',
    country: 'Georgia',
    countrySlug: 'georgia',
    university: 'Caucasus University, Tbilisi (transferred from VNMU, Ukraine)',
    image: '/img/p0e3c6g9_f580e8fe-aaf4-4096-b600-a13e463bb6f7.webp',
    quote: 'I started MBBS at VNMU in Ukraine, and when the war broke out my world turned upside down. Patrick sir and his team helped me transfer to Caucasus University, Georgia without losing a single semester. Today I hold my Medical Doctor degree and have cleared FMGE in my first attempt with 220 marks — none of this would have been possible without Patrick\'s Edu Care standing beside us during the toughest time.',
    parentQuote: '"When the war started, we had no idea what would happen to our daughter\'s future. Patrick\'s team gave us hope and a plan within days — they brought our girl home safe and her studies on track." — Dr. Anamika\'s Family',
    outcome: 'Graduated 2024 from Caucasus University · Cleared FMGE in 1st attempt with 220 marks · Currently doing internship in Kerala',
    badges: ['FMGE 1st Attempt', '220 Marks', 'Ukraine War Transfer']
  },
  {
    slug: 'dr-fenila-pious-armenia-mbbs',
    name: 'Dr. Fenila Pious',
    from: 'Kerala',
    age: 25,
    year: '2025',
    program: 'MBBS',
    programSlug: 'mbbs',
    country: 'Armenia',
    countrySlug: 'armenia',
    university: 'Yerevan Haybusak University, Armenia (transferred from VNMU, Ukraine)',
    image: '/img/4jqhj98d_9c5aac7d-e122-4551-afe8-b83c60175d24.webp',
    quote: 'I began my MBBS journey at VNMU in Ukraine, but the war forced me to think fast. Patrick sir secured my transfer to Armenia and made sure I never lost momentum in my studies. I graduated Class of 2025 and cleared FMGE in my first attempt — proof that even in the toughest circumstances, with the right guidance, dreams don\'t have to break.',
    parentQuote: '"What we feared was the end of her medical journey turned into a fresh beginning thanks to Patrick\'s team. Their network and quick action saved her career." — Dr. Fenila\'s Family',
    outcome: 'Graduated 2025 (MBBS, Class of 2025) · Cleared FMGE in 1st attempt · Indian medical license secured',
    badges: ['FMGE 1st Attempt', 'Class of 2025', 'Ukraine → Armenia Transfer']
  },
  {
    slug: 'dr-sreelakshmi-ku-armenia-mbbs',
    name: 'Dr. Sreelakshmi K U',
    from: 'Kerala',
    age: 25,
    year: '2025',
    program: 'MBBS',
    programSlug: 'mbbs',
    country: 'Armenia',
    countrySlug: 'armenia',
    university: 'Yerevan Haybusak University, Armenia (transferred from VNMU, Ukraine)',
    image: '/img/j8xrvb3n_7652a910-7ca4-4a0c-96b5-40268ec6b5e2.webp',
    quote: 'I started MBBS at VNMU in Ukraine and the war could have ended my journey. Patrick sir personally arranged my transfer to Armenia and made sure my credits and clinical training carried over smoothly. I graduated Class of 2025 and cleared FMGE in my very first attempt — Patrick\'s Edu Care turned a frightening chapter into the proudest moment of my life.',
    parentQuote: '"When the war broke out we cried every day. Patrick and his team brought our daughter back to her studies and now we have a doctor in our family." — Dr. Sreelakshmi\'s Family',
    outcome: 'Graduated 2025 (MBBS, Class of 2025) · Cleared FMGE in 1st attempt · Indian medical license secured',
    badges: ['FMGE 1st Attempt', 'Class of 2025', 'Ukraine → Armenia Transfer']
  },
  {
    slug: 'dr-sibiya-stanley-ukraine-mbbs',
    name: 'Dr. Sibiya Stanley',
    from: 'Kerala',
    age: 26,
    year: '2025',
    program: 'MBBS',
    programSlug: 'mbbs',
    country: 'Ukraine',
    countrySlug: 'ukraine',
    university: 'MBBS Graduate · Ukraine',
    image: '/img/alqk4avi_img_4499.webp',
    quote: 'I originally went through another agency and they left me high and dry in Ukraine. Patrick chettan stepped in and helped me with everything — especially during COVID and the war in Ukraine, when my parents were terrified about my safety. If he hadn\'t been there to help, I don\'t know what we would have done. Thank god he was. Today I\'m a successful doctor and preparing for FMGE in India.',
    parentQuote: '"Another agency abandoned our daughter in a foreign country during a pandemic and a war. Patrick stepped in like family — kept us updated, brought her home safely, and helped her finish her degree. We are forever grateful." — Dr. Sibiya\'s Family',
    outcome: 'Graduated MBBS · Survived COVID & Ukraine war with Patrick\'s support · Currently preparing for FMGE in India',
    badges: ['Rescued from Failed Agency', 'COVID & War Support', 'FMGE Aspirant']
  },
  {
    slug: 'dr-aswin-robinson-preetha-mbbs',
    name: 'Dr. Aswin Robinson Preetha',
    from: 'Kerala',
    age: 25,
    year: '2024',
    program: 'MBBS',
    programSlug: 'mbbs',
    country: 'Georgia',
    countrySlug: 'georgia',
    university: 'MBBS Graduate · Started in Ukraine, completed in Georgia · Class of 2024',
    image: '/img/fvqfkfmo_img_9682.webp',
    quote: 'I am so happy and my family is proud that I\'m finally a doctor. I first started studying engineering in Bangalore, then prepared IELTS for Canada — when I was nowhere and completely fed up, Dr. Patrick promised my parents that he would hand-hold me and make me a doctor. I began my MBBS in Ukraine, but when the war broke out it could have ended everything — Dr. Patrick stepped in, arranged my safe transfer to Georgia and made sure I finished my degree without losing time. My parents didn\'t believe in me — but they believed in Dr. Patrick. Today I have graduated as a doctor and I could feel how happy my parents were that day. Thanks chettan — you were like my brother and mentor.',
    parentQuote: '"After engineering didn\'t work and IELTS for Canada fell through, we had lost hope in our son. When the Ukraine war hit, we were terrified. Dr. Patrick personally promised us he would make him a doctor — and he kept his word, even arranging his transfer to Georgia. Today our son is a doctor because of him." — Dr. Aswin\'s Family',
    outcome: 'Switched career from engineering · Started MBBS in Ukraine · Transferred to Georgia during war · Graduated Class of 2024',
    badges: ['Career Switcher', 'Class of 2024', 'Ukraine → Georgia War Transfer']
  }
];

export const getStoryBySlug = (slug) => successStories.find((s) => s.slug === slug);

// Live ticker — recent activity feed. Order: most recent first.
// REPLACE WITH REAL UPDATES — keep entries to 1 sentence, add new ones via this file.
export const liveActivity = [
  { emoji: '🩺', text: 'Dr. Gayathri cleared FMGE in 1st attempt with 227 marks · Class of 2025' },
  { emoji: '🎓', text: 'Dr. Sreelakshmi graduated MBBS, Class of 2025 (Armenia) · last month' },
  { emoji: '✨', text: 'Spring 2026 Georgia batch — 12 admissions confirmed · this week' },
  { emoji: '📞', text: 'Free counselling sessions booked: 47 · this week' },
  { emoji: '🏫', text: 'New batch landed at Caucasus University · 3 days ago' },
  { emoji: '🛫', text: 'September 2025 batch sent off to Georgia · few months ago' }
];

// Parent testimonials — separate from student quotes for the dedicated parents strip.
// REPLACE WITH REAL PARENT TESTIMONIALS.
export const parentTestimonials = [
  {
    name: 'Mrs. Latha Nair',
    relation: 'Parent of a Patrick\'s Edu Care student — Georgia',
    quote: 'Patrick sir personally called us every week for the first month. That care is something money can\'t buy.',
    image: ''
  },
  {
    name: 'Mr. Suresh Krishnan',
    relation: 'Parent of an MBBS student — Georgia',
    quote: 'We compared 6 consultancies. Only Patrick\'s gave us written cost breakdowns with no hidden fees. That honesty sealed it.',
    image: ''
  },
  {
    name: 'Mrs. Geetha Joseph',
    relation: 'Parent of a BSc Nursing student — Bulgaria',
    quote: 'Our daughter is now in the UK earning ₹3.5L per month. Patrick\'s changed our family\'s trajectory.',
    image: ''
  }
];
